import { __decorate, __metadata } from "tslib";
import { PlatformPrivateServices } from '../PlatformPrivateServices';
import { ApiConfig, Public, Private } from '../limitPrivateAPI';
export class PrivateAPINamespace {
    constructor(hostType, ps) {
        this.hostType = hostType;
        this.hostType = hostType;
        this.ps = ps;
    }
    waitForChangesApplied() {
        return new Promise((resolve) => this.ps.ds.waitForChangesApplied(resolve));
    }
}
__decorate([
    ApiConfig(Private),
    __metadata("design:type", PlatformPrivateServices)
], PrivateAPINamespace.prototype, "ps", void 0);
__decorate([
    ApiConfig(Public),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], PrivateAPINamespace.prototype, "waitForChangesApplied", null);
//# sourceMappingURL=PrivateAPINamespace.js.map